export default class FaqSection {
    static init(): void {
        // Ošetříme, pokud FAQ sekce na stránce nejsou
        const faqSections = document.querySelectorAll('.js-faq-section-init');
        if (!faqSections.length) {
            return;
        }

        this.faqItemInit();
    }

    static faqItemInit(): void {
        // Najdeme všechny FAQ sekce s init třídou
        const faqSections = document.querySelectorAll('.js-faq-section-init');

        faqSections.forEach((section: Element) => {
            this.initFaqSection(section);
        });
    }

    private static initFaqSection(section: Element): void {
        // Najdeme všechny FAQ itemy v této sekci
        const faqItems = section.querySelectorAll('.faq-item');

        faqItems.forEach((item: Element) => {
            const trigger = item.querySelector('.faq-item__trigger') as HTMLElement;
            const content = item.querySelector('.faq-item__content') as HTMLElement;

            if (!trigger || !content) return;

            // Nastavíme počáteční stav pro animaci
            this.setupInitialState(item as HTMLElement, content);

            // Přidáme event listener na trigger
            trigger.addEventListener('click', (e: Event) => {
                e.preventDefault();
                this.toggleFaqItem(item as HTMLElement, content);
            });
        });
    }

    private static setupInitialState(item: HTMLElement, content: HTMLElement): void {
        if (item.classList.contains('is-active')) {
            // Pokud je item defaultně otevřený, nastavíme výšku
            content.style.maxHeight = content.scrollHeight + 'px';
            content.style.overflow = 'hidden';
        } else {
            // Pokud je zavřený, nastavíme výšku na 0
            content.style.maxHeight = '0px';
            content.style.overflow = 'hidden';
        }

        // Přidáme transition pro plynulou animaci
        content.style.transition = 'max-height 0.3s ease-out';
    }

    private static toggleFaqItem(item: HTMLElement, content: HTMLElement): void {
        const isActive = item.classList.contains('is-active');

        if (isActive) {
            // Zavíráme item
            item.classList.remove('is-active');
            content.style.maxHeight = '0px';
        } else {
            // Otevíráme item
            item.classList.add('is-active');
            content.style.maxHeight = content.scrollHeight + 'px';

            // Po dokončení animace nastavíme auto pro dynamický obsah
            setTimeout(() => {
                if (item.classList.contains('is-active')) {
                    content.style.maxHeight = 'auto';
                }
            }, 300); // Doba odpovídající transition
        }
    }
}
